import { GsbModule } from "./gsb-module.model";

export class GsbMlContent {
     _entDefName?: string;
     tr_tr?: string;
     helpPage_id?: string;
     name?: string;
     ko_kr?: string;
     lastUpdatedBy_id?: string;
     pt_pt?: string;
     it_it?: string;
     module?: GsbModule;
     hi_in?: string;
     ar_sa?: string;
     lastUpdateDate?: Date;
     en_us?: string;
     id?: string;
     fr_fr?: string;
     ja_jp?: string;
     docTemplate_id?: string;
     title?: string;
     de_de?: string;
     ru_ru?: string;
     is?: boolean;
     zh_cn?: string;
     module_id?: string;
     createDate?: Date;
     widget_id?: string;
     createdBy_id?: string;
     es_es?: string;

     constructor(obj?: Partial<GsbMlContent>) {
         Object.assign(this, obj);
         this._entDefName = "GsbMlContent";
     }
}